import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import css from './CheckboxButton.module.less';
import Icon from '../Icon';

export default function CheckboxButton({
  solid = true,
  selected = false,
  clickHandler,
  children,
}) {
  return (
    <div
      className={clsx(
        css.option,
        { [css['solid-button']]: solid },
        { [css['clear-button']]: !solid },
        { [css.selected]: selected }
      )}
      onClick={clickHandler}
    >
      {!solid && (
        <Icon name="ok" className={clsx(css.ok, { [css.hide]: !selected })} />
      )}
      <div className={clsx({ [css['clear-inner']]: !solid })}>{children}</div>
    </div>
  );
}

CheckboxButton.propTypes = {
  option: PropTypes.string,
  solid: PropTypes.bool,
  selected: PropTypes.bool,
  clickHandler: PropTypes.func,
  children: PropTypes.node,
};
